import React from "react";

export type SelectionOption = {
    option: string;
    enabled: boolean;
};

export type MultiSelectProps = {
    name: string;
    options: SelectionOption[];
    value?: string;
    onChange?: (name: string, value: string) => void;
};

export default function MultiSelect({ name, options, value, onChange }: MultiSelectProps) {
    const selectedOptions = value ? value.split(",") : [];

    const toggleSelection = (option: string) => {
        let updatedSelection;
        if (selectedOptions.includes(option)) {
            updatedSelection = selectedOptions.filter(item => item !== option);
        } else {
            updatedSelection = [...selectedOptions, option];
        }
        if (onChange) {
            onChange(name, updatedSelection.join(","));
        }
    };

    return (
        <div className="form-group flex flex-wrap gap-2 p-4">
            {options.map((option: SelectionOption) => (
                <div
                    key={option.option}
                    className={`px-4 py-2 border rounded cursor-pointer ${selectedOptions.includes(option.option) ? "bg-blue-500 text-white" : "bg-gray-200"}`}
                    onClick={() => toggleSelection(option.option)}
                >
                    {option.option}
                </div>
            ))}
        </div>
    );
}
